import { ROUTES as AI_CODING_OUTPUTS_ROUTES } from "@/ai-coding-outputs/navigation";
import { ROUTES as ADMIN_CODING_ROUTES } from "@/admin-coding-dashboard/navigation";
import { useAuth } from "@/auth/AuthProvider";
import { SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar";
import { supabase } from "@/integrations/supabase/client";
import { ROUTES as RAW_FILES_VIEWER_ROUTES } from "@/raw-files-viewer/navigation";
import { ROUTES as FORM_READ_CORRECTIONS_ROUTES } from "@/form-read-corrections/navigation";
import { ROUTES as RELEVANCE_REVIEW_ROUTES } from "@/relevance-review/navigation";
import { ROUTES as USER_ROUTES } from "@/user/navigation";
import { ROUTES as TEST_DATA_ROUTES } from "@/test-data/navigation";
import {
  BarChart3,
  ClipboardCheck,
  FileCheck,
  FileSearch,
  FileText,
  LogOut,
  Send,
  Settings,
  TestTube,
  GraduationCap,
} from "lucide-react";
import { useCallback } from "react";
import { Link, useNavigate } from "react-router";

const ClinicalCoderAdminSidebarMenuItems = () => {
  const { role } = useAuth();

  if (role !== "clinical_coder_admin") {
    return null;
  }

  return (
    <>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Coding Dashboard">
          <Link to={`${ADMIN_CODING_ROUTES.codingDashboard.route}`}>
            <BarChart3 className="h-4 w-4" />
            <span>Coding Dashboard</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Raw Files Viewer">
          <Link to={`${RAW_FILES_VIEWER_ROUTES.rawFilesViewer.route}`}>
            <FileSearch className="h-4 w-4" />
            <span>Raw Files Viewer</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Relevance Review">
          <Link to={RELEVANCE_REVIEW_ROUTES.relevanceReview.route}>
            <ClipboardCheck className="h-4 w-4" />
            <span>Relevance Review</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Form-read Corrections">
          <Link to={FORM_READ_CORRECTIONS_ROUTES.formReadCorrections.route}>
            <FileCheck className="h-4 w-4" />
            <span>Form-read Corrections</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Approved Results">
          <Link to={`${AI_CODING_OUTPUTS_ROUTES.unwrittenEncounterReview.route}`}>
            <Send className="h-4 w-4" />
            <span>Approved Results</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Test Data">
          <Link to={TEST_DATA_ROUTES.testData.route}>
            <TestTube className="h-4 w-4" />
            <span>Test Data</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Test Runs">
          <Link to="/test-data/runs">
            <GraduationCap className="h-4 w-4" />
            <span>Test Runs</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </>
  );
};

function ClinicalCoderSidebarMenuItems() {
  const navigate = useNavigate();
  const handleLogout = useCallback(async () => {
    await supabase.auth.signOut();
    navigate("/auth");
  }, [navigate]);

  return (
    <>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Coding Outputs">
          <Link to={`${AI_CODING_OUTPUTS_ROUTES.aiCodingOutputs.route}`}>
            <FileText className="h-4 w-4" />
            <span>Coding Outputs</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <ClinicalCoderAdminSidebarMenuItems />
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Settings">
          <Link to={`${USER_ROUTES.settings.route}`}>
            <Settings className="h-4 w-4" />
            <span>Settings</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <div className="flex-1" />
      <SidebarMenuItem>
        <button
          onClick={handleLogout}
          className="flex items-center w-full px-4 py-2 text-red-600 hover:bg-red-50 transition-colors"
          style={{ marginTop: "auto" }}
        >
          <LogOut className="h-4 w-4 mr-2" />
          <span>Logout</span>
        </button>
      </SidebarMenuItem>
    </>
  );
}

export default ClinicalCoderSidebarMenuItems;
